@if (calendarInformations) {
<div class="calendar-container">
    <div class="title">
        <fa-icon [icon]="faAngleRight"></fa-icon>
        <span>
            {{ 'Calendar.Title' | translate }}
            {{ calendarInformations.name ? '"' + calendarInformations.name + '"' : calendarInformations.id ? '"' + calendarInformations.id + '"' : '' }}
        </span>
    </div>

    <div class="content">
        @if (calendarInformations !== undefined) {
        <form [formGroup]="calendarForm" (ngSubmit)="onSubmit()">
            <div class="form-content">
                <mat-card appearance="outlined" class="box">
                    <mat-card-content>
                        <div class="card-content">
                            <div>
                                <form>
                                    <mat-form-field>
                                        <mat-label>{{ 'Calendar.CalendarType' | translate }}</mat-label>
                                        <mat-select [(value)]="currentCalendarType" (selectionChange)="calendarTypeChange()">
                                            @for (calendarType of calendarTypes; track calendarType) {
                                            <mat-option [value]="calendarType">{{ 'Calendar.' + calendarType | translate }}</mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                </form>
                            </div>

                            <div>
                                <mat-form-field>
                                    <mat-label>{{ 'Calendar.NamePlaceholder' | translate }}</mat-label>
                                    <input matInput formControlName="name" required />
                                </mat-form-field>
                            </div>

                            @switch (currentCalendarType) { @case ('Periodic') {
                            <div>
                                <span>
                                    <mat-checkbox #allDaysCheckbox [checked]="allDays" (change)="allDaysChange($event.checked)">
                                        {{ 'EnumDaysOfWeek.allDays' | translate }}
                                    </mat-checkbox>
                                    <mat-checkbox #weekDaysCheckbox [checked]="weekDays" (change)="weekDaysChange($event.checked)">
                                        {{ 'EnumDaysOfWeek.weekDays' | translate }}
                                    </mat-checkbox>
                                    <mat-checkbox #weekEndsCheckbox [checked]="weekEnds" (change)="weekEndsChange($event.checked)">
                                        {{ 'EnumDaysOfWeek.weekEnds' | translate }}
                                    </mat-checkbox>
                                </span>
                                <span>
                                    <ul>
                                        @for (day of week; track day) {
                                        <mat-checkbox [checked]="day.checked" (change)="dayChange(); day.checked = !day.checked">
                                            {{ 'EnumDaysOfWeek.' + day.name | translate }}
                                        </mat-checkbox>
                                        }
                                    </ul>
                                </span>
                            </div>
                            <div class="period-form">
                                <mat-form-field>
                                    <mat-label>{{ 'Calendar.PeriodPlaceholder' | translate }}</mat-label>
                                    <mat-date-range-input [rangePicker]="rangePicker" (keyup.enter)="addPeriod()">
                                        <input matStartDate placeholder="Début" formControlName="startPeriod" />
                                        <input matEndDate placeholder="Fin" formControlName="endPeriod" />
                                    </mat-date-range-input>
                                    <mat-hint>{{ dateFormat }} - {{ dateFormat }}</mat-hint>
                                    <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
                                    <mat-date-range-picker #rangePicker>
                                        <mat-date-range-picker-actions>
                                            <button mat-button matDateRangePickerCancel>{{ 'Calendar.CancelPlaceholder' | translate }}</button>
                                            <button mat-raised-button color="primary" matDateRangePickerApply (click)="addPeriod()">
                                                {{ 'Calendar.AddPlaceholder' | translate }}
                                            </button>
                                        </mat-date-range-picker-actions>
                                    </mat-date-range-picker>
                                </mat-form-field>
                                @if (periods.length > 0) {
                                <mat-list>
                                    @for (period of periods; track period) {
                                    <mat-list-item>
                                        <div class="list-item">
                                            {{ period.start | translateDate : 'shortDate' }} - {{ period.end | translateDate : 'shortDate' }}
                                            <button mat-icon-button type="button" (click)="deletePeriod(period)">
                                                <mat-icon>delete</mat-icon>
                                            </button>
                                        </div>
                                    </mat-list-item>
                                    }
                                </mat-list>
                                }
                            </div>
                            } @case ('Dates') {
                            <div class="days-form">
                                <mat-form-field>
                                    <mat-label>{{ 'Calendar.DatePlaceholder' | translate }}</mat-label>
                                    <input matInput [matDatepicker]="datepicker" formControlName="date" (keyup.enter)="addDate()" />
                                    <mat-hint>{{ dateFormat }}</mat-hint>
                                    <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
                                    <mat-datepicker #datepicker>
                                        <mat-datepicker-actions>
                                            <button mat-button matDatepickerCancel>{{ 'Calendar.CancelPlaceholder' | translate }}</button>
                                            <button mat-raised-button color="primary" (click)="addDate()" matDatepickerApply>{{ 'Calendar.AddPlaceholder' | translate }}</button>
                                        </mat-datepicker-actions>
                                    </mat-datepicker>
                                </mat-form-field>
                                @if (dates.length > 0) {
                                <mat-list>
                                    @for (date of dates; track date) {
                                    <mat-list-item>
                                        <div class="list-item">
                                            {{ date | translateDate : 'shortDate' }}
                                            <button mat-icon-button type="button" (click)="deleteDate(date)">
                                                <mat-icon>delete</mat-icon>
                                            </button>
                                        </div>
                                    </mat-list-item>
                                    }
                                </mat-list>
                                }
                            </div>
                            }}

                            <div class="hours-form">
                                <ngx-mat-timepicker formControlName="startHour"></ngx-mat-timepicker>
                                -
                                <ngx-mat-timepicker formControlName="endHour"></ngx-mat-timepicker>
                                <button class="hours-button" mat-icon-button type="button" (click)="addTime()">
                                    <mat-icon color="accent">schedule</mat-icon>
                                </button>
                                @if (hours.length > 0) {
                                <mat-list>
                                    @for (hour of hours; track hour) {
                                    <mat-list-item>
                                        <div class="list-item">
                                            {{ hour.start | translateDate : 'hours' }} - {{ hour.end | translateDate : 'hours' }}
                                            <button mat-icon-button type="button" (click)="deleteHours(hour)">
                                                <mat-icon>delete</mat-icon>
                                            </button>
                                        </div>
                                    </mat-list-item>
                                    }
                                </mat-list>
                                }
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
            <div class="save-button">
                <button mat-stroked-button type="button" color="accent" routerLink="/calendars">{{ 'Calendar.CancelButton' | translate }}</button>
                <button mat-raised-button color="accent" [disabled]="!calendarForm.valid" type="submit">{{ 'Calendar.SubmitButton' | translate }}</button>
            </div>
        </form>
        }
    </div>
</div>
}
